import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';

export default function PrivacyAndCookies() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-gray-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="border-0 shadow-xl">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <Shield className="w-8 h-8 text-orange-500" />
              <CardTitle className="text-3xl">Privacidad y Cookies</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <h2>Política de Privacidad</h2>
            
            <h3>1. Responsable del Tratamiento</h3>
            <p>
              <strong>Identidad:</strong> Strategos Overland by Javi Garmendia<br/>
              <strong>Dirección:</strong> Calle Turín 25, Parla (Madrid) 28983<br/>
              <strong>Email:</strong> hola@sttgs-overland.com
            </p>

            <h3>2. Finalidad del Tratamiento</h3>
            <p>Los datos personales recogidos serán tratados con las siguientes finalidades:</p>
            <ul>
              <li>Gestión de la inscripción a eventos</li>
              <li>Envío de comunicaciones relacionadas con los eventos</li>
              <li>Cumplimiento de obligaciones legales</li>
              <li>Gestión de consultas y solicitudes</li>
            </ul>

            <h3>3. Base Legal</h3>
            <p>
              El tratamiento de sus datos se basa en el consentimiento del interesado y en la ejecución 
              del contrato de prestación de servicios.
            </p>

            <h3>4. Datos Recogidos</h3>
            <p>Recogemos los siguientes tipos de datos personales:</p>
            <ul>
              <li>Datos de identificación: nombre, DNI, email, teléfono</li>
              <li>Datos de la motocicleta: marca, modelo, matrícula</li>
              <li>Documentación: permiso de circulación, ficha técnica, seguro</li>
              <li>Fotografías para identificación</li>
            </ul>

            <h3>5. Conservación de Datos</h3>
            <p>
              Los datos personales serán conservados mientras se mantenga la relación contractual y, 
              posteriormente, durante los plazos legalmente establecidos.
            </p>

            <h3>6. Derechos del Usuario</h3>
            <p>El usuario tiene derecho a:</p>
            <ul>
              <li>Acceder a sus datos personales</li>
              <li>Rectificar datos inexactos o incompletos</li>
              <li>Solicitar la supresión de sus datos</li>
              <li>Oponerse al tratamiento de sus datos</li>
              <li>Solicitar la limitación del tratamiento</li>
              <li>Portabilidad de los datos</li>
            </ul>

            <h3>7. Seguridad</h3>
            <p>
              Strategos Overland ha adoptado medidas técnicas y organizativas para garantizar la seguridad 
              de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
            </p>

            <hr className="my-8" />

            <h2>Política de Cookies</h2>

            <h3>¿Qué son las cookies?</h3>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita 
              un sitio web. Permiten que el sitio web recuerde sus acciones y preferencias durante un período de tiempo.
            </p>

            <h3>Tipos de Cookies que Utilizamos</h3>
            
            <h4>Cookies Técnicas (Necesarias)</h4>
            <p>
              Estas cookies son esenciales para el funcionamiento del sitio web. Incluyen cookies de sesión 
              que permiten la autenticación del usuario.
            </p>

            <h4>Cookies de Análisis</h4>
            <p>
              Nos ayudan a entender cómo los usuarios interactúan con el sitio web, proporcionando información 
              sobre las áreas visitadas, el tiempo de permanencia y los problemas encontrados.
            </p>

            <h3>Gestión de Cookies</h3>
            <p>
              Puede configurar su navegador para rechazar cookies o para que le avise cuando se envíen cookies. 
              Sin embargo, algunas partes del sitio web pueden no funcionar correctamente sin cookies.
            </p>

            <h4>Cómo desactivar las cookies:</h4>
            <ul>
              <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
              <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies</li>
              <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
              <li><strong>Edge:</strong> Configuración → Cookies y permisos del sitio</li>
            </ul>

            <h3>Actualización de la Política</h3>
            <p>
              Esta política de privacidad y cookies puede ser actualizada. Se recomienda revisar esta página 
              periódicamente para estar informado de cualquier cambio.
            </p>

            <p className="text-sm text-gray-600 mt-8">
              <strong>Última actualización:</strong> Noviembre 2025
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
